import React from "react";
import { rowClass as defaultRowClass, StatusPill } from "./Primitives";

/**
 * Generic table for ops entries.
 * columns: [{ key, label, render?: (val, row) => node, className? }]
 */
export default function EntryTable({ columns, rows, onRowClick, emptyText = "No entries.", rowActions, rowClass }) {
  const hasActions = typeof rowActions === "function";
  const cls = typeof rowClass === "function" ? rowClass : defaultRowClass;
  return (
    <table className="w-full text-sm">
      <thead>
        <tr className="text-left text-[10px] uppercase tracking-[0.08em] text-neutral-500 font-semibold bg-[var(--rw-surface-2)]">
          {columns.map((c) => (
            <th key={c.key} className={`py-2 px-3 ${c.className || ""}`}>
              {c.label}
            </th>
          ))}
          {hasActions && <th className="py-2 px-3 w-px" />}
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 && (
          <tr>
            <td colSpan={columns.length + (hasActions ? 1 : 0)} className="px-3 py-6 text-center text-neutral-400">
              {emptyText}
            </td>
          </tr>
        )}
        {rows.map((r, i) => {
          // Sentinel "now" row — render a thin red bar across all columns.
          if (r._now) {
            return (
              <tr key={`now-${i}`} data-testid="now-line">
                <td
                  colSpan={columns.length + (hasActions ? 1 : 0)}
                  className="p-0 relative"
                >
                  <div className="relative h-[2px] bg-[#E5484D]">
                    <span className="absolute -top-[7px] left-0 inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.08em] font-semibold text-white bg-[#E5484D] px-1.5 py-[1px] rounded-[2px]">
                      Now {r._nowLabel || ""}
                    </span>
                  </div>
                </td>
              </tr>
            );
          }
          return (
            <tr
              key={r.id || i}
              className={`border-t border-[var(--rw-border)] hover:bg-[var(--rw-surface-2)] cursor-pointer ${cls(r)}`}
              onClick={() => onRowClick && onRowClick(r)}
              data-testid={`entry-row-${r.id || i}`}
            >
              {columns.map((c) => (
                <td key={c.key} className={`py-2 px-3 align-top ${c.className || ""}`}>
                  {c.render
                    ? c.render(r[c.key], r)
                    : c.key === "status"
                    ? <StatusPill value={r[c.key]} />
                    : (r[c.key] || "")}
                </td>
              ))}
              {hasActions && (
                <td className="py-2 px-3 align-top text-right">{rowActions(r)}</td>
              )}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
